import axios from 'axios';

export const getDropdownBidangUsaha = async () => {
    return await axios.get(`${window._HOST}admin/bidangUsaha/dropdown`, {withCredentials: true});
}

export const getAllDataTableBidangUsaha = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/bidangUsaha/dataTable?seach-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/bidangUsaha/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const insertNewBidangUsaha = async (formData) => {
    return await axios.post(`${window._HOST}admin/bidangUsaha`, formData, {withCredentials: true})
}

export const updateBidangUsaha = async (formData, id_bidang_usaha) => {
    return await axios.put(`${window._HOST}admin/bidangUsaha/${id_bidang_usaha}`, formData, {withCredentials: true})
}

export const deleteBidangUsaha = async (id_bidang_usaha) => {
    return await axios.delete(`${window._HOST}admin/bidangUsaha/${id_bidang_usaha}`, {withCredentials: true})
}